<div class="authenticator-setup-content">
    @if (setupLoading() && !verificationStepReady() && !showCancelButton()) {
        <!-- Mandatory login-time flow only (showCancelButton false): gives the user context on this
             otherwise cancel-less screen while enrollAuthenticator() loads. Account Settings' voluntary
             flow keeps the bare spinner below with no heading. -->
        <h1 class="suif-h3 setup-heading">Setting Up Authenticator App</h1>
    }

    @if (setupLoading()) {
        <app-wait></app-wait>
    }

    @if (!setupLoading() && !verificationStepReady()) {
        <app-message-box [content]="errors"></app-message-box>

        <div class="button-row">
            @if (showCancelButton()) {
                <button type="button" class="btn btn-secondary" (click)="cancelled.emit()">Cancel</button>
            }
            <button type="button" class="btn btn-primary" (click)="loadAuthenticatorSetup()">Try Again</button>
        </div>
    }

    @if (verificationStepReady()) {
        <h1 class="suif-h3 verification-heading">Enter Verification Code</h1>

        <p class="suif-body-copy verification-instructions">
            Scan the QR code with your authenticator app, then enter the 6-digit code.
        </p>

        @if (hasQrCode()) {
            <div class="qr-code-container">
                <img [src]="qrCodeDataUrl()" alt="QR code for authenticator app" class="qr-code-image" />
            </div>
        }

        <div class="manual-setup">
            <p class="suif-body-copy-small manual-setup-instructions">
                Can't scan? Enter this key manually in your authenticator app:
            </p>
            <div class="setup-key">
                <code>{{ setupKey() }}</code>
            </div>
        </div>

        @if (errors.validationError) {
            <app-message-box level="error" [messages]="['Verification failed. Please try again.']"></app-message-box>
        }

        <form [formGroup]="verificationForm" (ngSubmit)="verifyCode()">
            <app-input
                formControlName="verificationCode"
                fieldId="verification-code"
                label="Verification Code"
                maxlength="6"
                inputmode="numeric"
                autocomplete="one-time-code"
                [errors]="errors.fieldErrors?.otp"
                [isDisabled]="verifyingCode()"
                isRequired
                autoFocus>
            </app-input>

            <div class="button-row">
                @if (showCancelButton()) {
                    <button type="button" class="btn btn-secondary" (click)="cancelled.emit()">Cancel</button>
                }
                <app-wait-button
                    buttonType="submit"
                    [waiting]="verifyingCode()"
                    label="Verify Code">
                </app-wait-button>
            </div>
        </form>
    }
</div>
